import { findSiblingsInDepartmentsTree } from 'util/findSiblingsInDepartmentTree';

import { DepartmentModel } from 'api/dto/Department.dto';
import {
  getRelativeOrderAbove,
  getRelativeOrderBelow,
  DepartmentPositionType,
} from 'model/DepartmentPositionType';

type GetNewOrder = (
  selectedDepartment: DepartmentModel,
  positionDepartmentId: number,
  positionType: DepartmentPositionType,
  departmentList: DepartmentModel[],
) => number[];

export const getNewDepartmentsOrder: GetNewOrder = (
  selectedDepartment,
  relativeDepartmentId,
  positionType,
  departmentList,
) => {
  const selectedDepartmentId = selectedDepartment.id;

  if (selectedDepartmentId === relativeDepartmentId) {
    console.warn('Cannot move department relative to itself!');
    return [];
  }

  const sameLevelDepartments = findSiblingsInDepartmentsTree(departmentList, selectedDepartmentId)
    .map((department) => department.id)
    .filter((id) => id !== selectedDepartmentId);

  const relativeIndex = sameLevelDepartments.indexOf(relativeDepartmentId);
  const beforeRelative = sameLevelDepartments.slice(0, relativeIndex);
  const afterRelative = sameLevelDepartments.slice(relativeIndex + 1);

  switch (positionType) {
    case 'Above':
      return getRelativeOrderAbove(
        beforeRelative,
        selectedDepartmentId,
        relativeDepartmentId,
        afterRelative,
      );
    case 'Below':
      return getRelativeOrderBelow(
        beforeRelative,
        selectedDepartmentId,
        relativeDepartmentId,
        afterRelative,
      );
  }
};
